var React = require('react');

function Email (props) {
    return React.createElement("svg",props);
}

Email.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000"};

module.exports = Email;

Email.default = Email;
